import React, { Component } from 'react';
import './index.scss';
import { ReactComponent as DownArrow } from '../../assets/images/triangle-down-arrow.svg';
import { KeyboardArrowLeft } from '@mui/icons-material';
import { FaPlus, FaMinus } from 'react-icons/fa';
import Offcanvas from 'react-bootstrap/Offcanvas';
import BookingSummary from '../BookingSummary';
import DeliveryType from '../Deliverytype';
import BookingSelection from '../BookingSelection';

class PurchaseFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      ticketSummarySectionHeight: 0,
      openTicketSummary: false,
      maxHeightForTicketSummary: 'auto',
    };
    this.ticketSummarySectionRef = React.createRef();
    this.purchaseFooterRef = React.createRef();
  }

  getItemTotalWithFreeQty = item => {
    var unitprice = parseFloat(item.unitprice) || 0;
    var modifiers = item.modifiers || [];
    var modifierGroups = item.modifierGroups || [];

    if (modifiers.length === 0) return unitprice;

    if (modifierGroups.length === 0) {
      modifiers.forEach(modifier => {
        unitprice += (parseFloat(modifier.unitprice) || 0) * (modifier.qty || 0);
      });
      return unitprice;
    }

    var consumedModifierIndexes = {};
    var totalModifiersPrice = 0;

    modifierGroups.forEach(group => {
      var freeQty = group.freeQty || 0;
      var selectedModifiers = [];
      var groupId = group.id || group.modifierGroupId || group.modifiergroupid || group.groupid || group.groupId;

      modifiers.forEach((modifier, modifierIndex) => {
        var modifierGroupId = modifier.modifierGroupId || modifier.modifiergroupid || modifier.modifier_group_id || modifier.groupid || modifier.groupId;
        if (groupId == null || modifierGroupId == null || String(groupId) !== String(modifierGroupId)) return;

        var qty = modifier.qty || 0;
        var price = parseFloat(modifier.unitprice) || 0;
        consumedModifierIndexes[modifierIndex] = true;
        for (var i = 0; i < qty; i++) {
          selectedModifiers.push(price);
        }
      });

      selectedModifiers.sort((a, b) => a - b);
      var remainingFreeQty = freeQty;
      var paidModifiers = [];
      selectedModifiers.forEach(price => {
        if (price > 0 && remainingFreeQty > 0) {
          remainingFreeQty -= 1;
        } else {
          paidModifiers.push(price);
        }
      });
      totalModifiersPrice += paidModifiers.reduce((sum, price) => sum + price, 0);
    });

    modifiers.forEach((modifier, modifierIndex) => {
      if (!consumedModifierIndexes[modifierIndex]) {
        totalModifiersPrice += (parseFloat(modifier.unitprice) || 0) * (modifier.qty || 0);
      }
    });

    return unitprice + totalModifiersPrice;
  };

  calculateTotal = () => {
    var totalTicketPricing = 0,
      totalFnbPricing = 0,
      totalTaxValue = window.constant.SHOW_TAX_VALUE_ON_ORDER_TOTAL_ON_SEAT_LAYOUT === 'true' ? this.props.ticketsTaxValue + this.props.fnbTaxValue : 0;
    this.props.ticketsDataForTicketSummary.length > 0 &&
      this.props.ticketsDataForTicketSummary.map(eachTicket => {
        var itemTotal = this.getItemTotalWithFreeQty(eachTicket);
        totalTicketPricing += eachTicket.qty * itemTotal;
      });

    this.props.fnbDataForTicketSummary.length > 0 &&
      this.props.fnbDataForTicketSummary.map(eachFnb => {
        var itemTotal = this.getItemTotalWithFreeQty(eachFnb);
        totalFnbPricing += eachFnb.qty * itemTotal;
      });
    return (totalTicketPricing + totalFnbPricing + totalTaxValue).toFixed(2);
  };

  populateTicketsForTicketSummary = () => {
    var returnTicketsDiv = [];
    this.props.ticketsDataForTicketSummary.length > 0 &&
      this.props.ticketsDataForTicketSummary.map(eachTicket => {
        returnTicketsDiv.push(
          <div className="eachTicketDiv">
            {/* <p className="eachTicketParagraph">
              <div className="eachTicketDescQtyPrice">
                <span className="name">{eachTicket.description}</span>
                <span className="eachQty">
                  {eachTicket.qty} x {eachTicket.unitprice.toFixed(2)}
                </span>
              </div>
            </p> */}
            <span className="name">{eachTicket.description}</span>
            <span className="eachQty">
              {eachTicket.qty} x {eachTicket.unitprice.toFixed(2)}
            </span>
            <p className="price">{parseFloat(eachTicket.unitprice * eachTicket.qty).toFixed(2)}</p>
          </div>
        );
      });

    return returnTicketsDiv;
  };

  populateFnBForTicketSummary = () => {
    var returnFnBDiv = [];
    this.props.fnbDataForTicketSummary.length > 0 &&
      this.props.fnbDataForTicketSummary.map((eachFnb, eachFnbIndex) => {
        var unitprice = eachFnb.unitprice;
        var totalModifiePrice = 0;
        var modifers = '';
        var smartModifiers = '';
        eachFnb.modifiers.length > 0 &&
          eachFnb.modifiers.map(modifier => {
            totalModifiePrice += modifier.unitprice * modifier.qty;
            modifers += modifier.description + ' x ' + modifier.qty + ', ';
          });
        unitprice += totalModifiePrice;
        eachFnb.smartModifiers.length > 0 &&
          eachFnb.smartModifiers.map(smartModifer => {
            smartModifiers += smartModifer.description + ', ';
          });

        returnFnBDiv.push(
          <div className="eachTicketDiv">
            {/* <p className="eachTicketParagraph">
              <div className="closeIcon" onClick={() => this.props.removeItemFromCart(eachFnbIndex)}>
                <IoMdCloseCircle />
              </div>
              <div className="eachTicketDescQtyPrice">
                <span className="name">{eachFnb.description}</span>
                {modifers.length == 0 && smartModifiers.length == 0 ? (
                  <></>
                ) : (
                  <span className="modifiers">
                    {`${modifers.length != 0 ? modifers.slice(0, -2) : ""}`}
                    {`${modifers.length != 0 && smartModifiers.length != 0 ? ", " : ""}`} {`${smartModifiers.length != 0 ? smartModifiers.slice(0, -2) : ""}`}
                  </span>
                )}
              </div>
            </p> */}
            <div className="name">
              <span>{eachFnb.description}</span>
              {modifers.length == 0 && smartModifiers.length == 0 ? (
                <></>
              ) : (
                <span className="modifiers">
                  {`${modifers.length != 0 ? modifers.slice(0, -2) : ''}`}
                  {`${modifers.length != 0 && smartModifiers.length != 0 ? ', ' : ''}`} {`${smartModifiers.length != 0 ? smartModifiers.slice(0, -2) : ''}`}
                </span>
              )}
            </div>

            <span className="eachQty">
              <div className="incDecDivForItem">
                <button type="button" class="btn btn-outline-secondary decButton" onClick={() => this.props.incDecItem('subtract', eachFnbIndex)}>
                  <FaMinus></FaMinus>
                </button>
                <button type="button" class="btn btn-outline-secondary itemQty">
                  {eachFnb.qty}
                </button>
                <button type="button" class="btn btn-outline-secondary incButton" onClick={() => this.props.incDecItem('add', eachFnbIndex)}>
                  <FaPlus></FaPlus>
                </button>
              </div>
              {/* x {unitprice.toFixed(2)} */}
            </span>
            <p>{parseFloat(unitprice * eachFnb.qty).toFixed(2)}</p>
          </div>
        );
      });
    return returnFnBDiv;
  };

  nextBtnClick = () => {
    this.props.nextBtnClick();
    this.setState({
      openTicketSummary: false,
    });
  };

  componentDidUpdate(prevProps) {

    if (prevProps.fnbDataForTicketSummary !== this.props.fnbDataForTicketSummary) {
      this.setState({
        fnbDataForTicketSummary: this.props.fnbDataForTicketSummary,
      });
    }

    const { fnbDataForTicketSummary, ticketsDataForTicketSummary } = this.props;
    if (this.state.openTicketSummary && fnbDataForTicketSummary.length == 0 && ticketsDataForTicketSummary.length == 0) {
      this.setState({
        openTicketSummary: false,
      });
    }
  }
  render() {
    const {
      fnbDataForTicketSummary,
      ticketsDataForTicketSummary,
      incDecItem,
      nextBtnText,
      nextBtnDisable,
      backBtnClick,
      handleDeliveryTypeSelection,
      handleBookingSelectionDrawer,
      isPickupAvailable
      , ticketsTaxValue, fnbTaxValue } = this.props;
    return (
      <React.Fragment>
        <section className="container-fluid sticky-bottom purchaseFooterDiv">
          <div className="purchase-footer" id="purchase-footer" ref={this.purchaseFooterRef}>
            <div className="back-btn">
              <KeyboardArrowLeft sx={{ color: 'var(--back-arrow-color)' }} />
              <a href="javascript:;" title="BACK" onClick={() => backBtnClick()}>
                BACK
              </a>
            </div>
            <section className="purchase-summary">
              <div className="ticket-summary" onClick={() => this.setState({ openTicketSummary: !this.state.openTicketSummary })}>
                <div className="purchase-grand-total">
                  {fnbDataForTicketSummary.length > 0 || ticketsDataForTicketSummary.length > 0 ? (
                    <p>
                      Total
                      <span>${this.calculateTotal()}</span>
                      <DownArrow className={this.state.openTicketSummary ? 'open' : 'close'} />
                    </p>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </section>
            <section className={`purchase-next ${nextBtnDisable ? 'disabled' : ''}`}>
              <button onClick={() => this.nextBtnClick()}>{nextBtnText}</button>
            </section>
          </div>
        </section>
        <div className="summary-bg">
          <div className={this.state.openTicketSummary ? 'open' : 'close'}>&nbsp;</div>
        </div>
        <Offcanvas
          show={this.state.openTicketSummary}
          placement={'bottom'}
          onHide={() =>
            this.setState({
              openTicketSummary: false,
            })
          }
          className="purchaseFooter"
        >
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <div id="ticketSummarySection" className="bookingSummary" ref={this.ticketSummarySectionRef} style={{ maxHeight: this.state.maxHeightForTicketSummary }}>
              <p className="bookingSummaryHeading">Booking Summary</p>
              <BookingSummary
                ticketsDataForTicketSummary={ticketsDataForTicketSummary}
                fnbDataForTicketSummary={fnbDataForTicketSummary}
                incDecItem={incDecItem}
                nextBtnClick={this.nextBtnClick}
                nextBtnText={nextBtnText}
                bookingFee={false}
                tax={window.constant.SHOW_TAX_VALUE_ON_ORDER_TOTAL_ON_SEAT_LAYOUT === 'true' ? ticketsTaxValue + fnbTaxValue : false}
              ></BookingSummary>
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        <Offcanvas show={this.props.showDeliveryTypeDrawer} placement={'bottom'} onHide={this.props.handleShowDeliveryTypeDrawer} className="purchaseFooter">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <DeliveryType
              fnbDataForTicketSummary={fnbDataForTicketSummary}
              handleDeliveryTypeSelection={handleDeliveryTypeSelection}
              isLoading={this.props.isLoading}
              isPickupAvailable={isPickupAvailable}
            />
          </Offcanvas.Body>
        </Offcanvas>

        <Offcanvas show={this.props.showBookingSelectionDrawer} placement={'bottom'} onHide={handleBookingSelectionDrawer} className="purchaseFooter booking-selection-drawer">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <BookingSelection
              handleFnbSectionDisable={this.props.handleFnbSectionDisable}
              updateBookedTicketDetails={this.props.updateBookedTicketDetails}
              handleBookingSelection={this.props.handleBookingSelection}
            />
          </Offcanvas.Body>
        </Offcanvas>
      </React.Fragment>
    );
  }
}

export default PurchaseFooter;
